import LlamadaService from './llamada_service.js'
import ConfigService from './config_service.js'

const llamada = new LlamadaService();
const configService = new ConfigService();
const config = configService.getConfig();

let estaLogueado = false;
let token = '';
let centro = 0;
let roles = [];

export default class LoginService {
	login(data) {
		data.action = "login";
		return llamada.sendPost(config.baseUrl + 'LoginWebService.php', data);
	}

	chkLogin(data) {
		data.action = "chk";
		return llamada.sendPost(config.baseUrl + 'LoginWebService.php?token=' + this.getToken(), data);
	}

	logout(data) {
		data.action = "logout";
		return llamada.sendPost(config.baseUrl + 'LoginWebService.php', data);
	}

	getEstaLogueado() {
		return estaLogueado;
	}

	setEstaLogueado(logueado) {
		estaLogueado = logueado;
	}

	getToken() {
		if (token == null || token == '') {
			try {
				token = localStorage.getItem('token');
			} catch (e) {
				return token;
			}
		}
		return token;
	}

	setToken(usrToken) {
		try {
			localStorage.setItem('token', usrToken);
		} catch (e) {
			token = usrToken;
			return e;
		}
		token = usrToken;
	}

	setUsrCentro(usrCentro) {
		try {
			localStorage.setItem('centro', usrCentro);
			centro = usrCentro;
		} catch (e) {
			return e;
		}
	}

	getUsrCentro() {
		try {
			centro = localStorage.getItem('token');
		} catch (e) {
			return centro;
		}
		return centro;
	}

	setUsrRoles(usrRoles) {
		try {
			localStorage.setItem('roles', usrRoles.join());
			roles = usrRoles;
		} catch (e) {
			return e;
		}
	}

	getUsrRoles() {
		try {
			roles = localStorage.getItem('roles');
		} catch (e) {
			return centro;
		}
		return roles.split(',');
	}

	hasPermission(moduleName, functionName) {
		if(moduleName) return true;
		if(functionName) return true;
		return true;
	}

	hasRol(rol) {
		let roles = this.getUsrRoles();
		return roles.includes(rol.toString());
	}

	esAdministrador() {
		return this.hasRol(1);
	}

	esUser() {
		return this.hasRol(2);
	}

	esFacturacion() {
		return this.hasRol(3);
	}
}